app.filter('truncate',
    function() {
        return function(input, length) {
            length = length ? length : 25;
            return _.truncate(input, {
                'length': length
            });
        };
    }
);